import React, { useEffect, useRef, useState } from 'react';
import { normalizeCollaboratorPicture } from '../../utils/mindmap/collaborators';
import './CollaboratorPresence.css';

function Avatar({ person }) {
  const [failed, setFailed] = useState(null);
  const url = normalizeCollaboratorPicture(person.pictureUrl);
  const initials = (person.displayName || 'Collaborator').trim().split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase();
  return <span className="collaborator-avatar">
    {url && url !== failed
      ? <img src={url} alt="" referrerPolicy="no-referrer" onError={() => setFailed(url)} />
      : <span aria-hidden="true">{initials}</span>}
  </span>;
}

export default function CollaboratorPresence({ participants = [], onReveal, isDarkMode = false }) {
  const details = useRef(null);
  useEffect(() => {
    const dismiss = event => {
      if (details.current?.open && !details.current.contains(event.target)) details.current.open = false;
    };
    window.addEventListener('pointerdown', dismiss);
    return () => window.removeEventListener('pointerdown', dismiss);
  }, []);
  if (!participants.length) return null;
  const status = person => person.editingNodeId ? 'Editing an idea' : person.selectedNodeId ? 'Viewing an idea' : 'On this map';
  return <details className="collaborator-presence" ref={details} data-export-ignore="true"
    style={{ '--presence-surface': isDarkMode ? '#27272a' : '#fff', '--presence-text': isDarkMode ? '#f7f7f8' : '#172033' }}
    onPointerDown={event => event.stopPropagation()}
    onKeyDown={event => {
      event.stopPropagation();
      if (event.key === 'Escape') { details.current.open = false; details.current.querySelector('summary')?.focus(); }
    }}>
    <summary aria-label={`People on this map: ${participants.length} other${participants.length === 1 ? '' : 's'}`}>
      <span className="collaborator-presence__stack">
        {participants.slice(0, 3).map(person => <span key={person.userId} title={`${person.displayName} · ${status(person)}`}><Avatar person={person} /></span>)}
        {participants.length > 3 && <span className="collaborator-presence__more">+{participants.length - 3}</span>}
      </span>
    </summary>
    <div className="collaborator-presence__panel" role="list" aria-label="Collaborators" data-viewport-occlusion="true">
      {participants.map(person => <div role="listitem" key={person.userId} className="collaborator-presence__person">
        <Avatar person={person} />
        <span><strong>{person.displayName}</strong><small>{status(person)}</small></span>
        {(person.editingNodeId || person.selectedNodeId) && <button type="button"
          aria-label={`Find ${person.displayName}'s idea`}
          onClick={() => { onReveal?.(person.editingNodeId || person.selectedNodeId); details.current.open = false; }}>
          Find
        </button>}
      </div>)}
    </div>
  </details>;
}
